import { Card, FormField, Input } from '@playerbase/ui';

import {
  type BuilderMetadata,
  type UsePlaytestBuilderState,
} from '../../../../games/use-playtest-builder-state.js';

interface MetadataCardProps {
  metadata: BuilderMetadata;
  builder: UsePlaytestBuilderState;
}

const FIELD_LABEL_CLASS =
  'font-mono text-[10px] font-semibold uppercase tracking-wider text-text-muted';

export function MetadataCard({ metadata, builder }: MetadataCardProps): JSX.Element {
  return (
    <Card>
      <Card.Header>
        <Card.Title>Playtest details</Card.Title>
        <Card.Description>
          Naming is portal-only - testers never see these.
        </Card.Description>
      </Card.Header>
      <Card.Content className="flex flex-col gap-4">
        <FormField>
          <FormField.Label className={FIELD_LABEL_CLASS} data-required>
            Playtest name
          </FormField.Label>
          <FormField.Control>
            <Input
              value={metadata.name}
              onChange={(e) => builder.updateMetadata({ name: e.target.value })}
              maxLength={80}
              placeholder="Closed alpha - wave 2"
            />
          </FormField.Control>
          <FormField.HelpText>Up to 80 characters.</FormField.HelpText>
        </FormField>

        <FormField>
          <FormField.Label className={FIELD_LABEL_CLASS}>
            Internal notes
          </FormField.Label>
          <FormField.Control>
            <Input
              value={metadata.internalDescription}
              onChange={(e) =>
                builder.updateMetadata({ internalDescription: e.target.value })
              }
              placeholder="Optional. e.g. 'Mid-build 0.4 - level 2 to 5 only.'"
            />
          </FormField.Control>
        </FormField>
      </Card.Content>
    </Card>
  );
}
